import React from 'react';
import EmailIcon from '../../common/EmailIcon';
import callIcon from '../../../images/normal_call_icon_u4.png';

const ContactUs = () => {
  return (<div className="contact-us-container">
    <h1 className="contact-us-container-help-label">Need Help?</h1>
    <div className="contact-us-container-contact-label">Contact Us</div>
    <div className="contact-us-container-row">
      <div className="contact-us-container-box">
        <div className="contact-us-container-box-email">
          <a href="mailto:clientservices.ms@mrisimmons.com​" title="Send us an email" className="contactus-links">
            <span className="contactus-email-icon"><EmailIcon /></span>
            <span className="contactus-text">
              clientservices.ms@mrisimmons.com
            </span>
          </a>
        </div>
      </div>
      <div className="contact-us-container-box">
        <div className="contact-us-container-box-web">
          <a href="https://www.mrisimmons.com​" className="contactus-links" title="Come to our website" target="_blank" rel="noopener noreferrer">
            <span className="contactus-web-icon" />
            <span className="contactus-text">
              www.mrisimmons.com
            </span>
          </a>
        </div>
      </div>
    </div>
    <div className="contact-us-container-row">
      <div className="contact-us-container-sc-box">
        <div className="contact-us-container-sc-box-label">We are Social!</div>
        <div className="contact-us-container-sc-box-social">
          <a href="https://twitter.com/MRI_Simmons" title="Twitter" target="_blank" rel="noopener noreferrer">
            <i className="contact-social-icon contact-us-container-sc-box-social-twitter" />
          </a>
          <a href="https://www.facebook.com/MRISimmons/" title="Facebook" target="_blank" rel="noopener noreferrer">
            <i className="contact-social-icon contact-us-container-sc-box-social-fb" />
          </a>
          <a href="https://www.linkedin.com/company/mri-simmons" title="LinkedIn" target="_blank" rel="noopener noreferrer">
            <i className="contact-social-icon contact-us-container-sc-box-social-link" />
          </a>
          <a href="https://www.youtube.com/c/MRISimmons" title="YouTube" target="_blank" rel="noopener noreferrer">
            <i className="contact-social-icon contact-us-container-sc-box-social-youtube" />
          </a>
        </div>
      </div>
      <div className="contact-us-container-box">
        <div>
          <img className="contact-us-container-box-call-icon" title="Call us" src={callIcon} alt="Twitter icon" />
        </div>
        <div>
          <div className="margin-bottom-last">Simmons Sales / Services</div>
        </div>
        <div>
          <div className="margin-bottom-last">(866) 256-4468</div>
        </div>
      </div>
    </div>
    <div className="contact-us-container-row">
      <div className="contact-us-container-sc-box">
        <div className="contact-us-container-sc-box-label">Request a change to a survey</div>
        <div className="contact-us-container-box-web">
          <a href="https://surf.mrisimmons.com" className="contactus-links" title="Come to our website" target="_blank" rel="noopener noreferrer">
            <span className="contactus-web-icon" />
            <span className="contactus-text">
              surf.mrisimmons.com
            </span>
          </a>
        </div>
        <div className="contact-us-container-sc-box-social" />
      </div>
    </div>
  </div>);
};

export default ContactUs;
